<template>
  <BBasicDialog ref="basicDialog">
    <template v-slot:content>
      <p class="mb-0">
        In <span class="time">{{ getExpInSecCounter }} Sekunden</span> werden
        Sie automatisch ausgeloggt.
      </p>
      <br />
      <p class="mb-0">Dabei gehen alle ungespeicherten Daten verloren.</p>
      <BHint
        v-if="statusNotifications != 'granted'"
        hint-text="Hinweis: Wenn Sie Benachrichtungen für diese Website zulassen, dann kann eine Benachrichtigung auch bei inaktivem Fenster erfolgen."
        style="margin-left: 4px"
      />
    </template>

    <template v-slot:dialog-actions>
      <v-col>
        <b-btn @click="preventLogout" block
          >Automatischen Logout verhindern</b-btn
        >
      </v-col>
    </template>
  </BBasicDialog>
</template>

<script>
// services
import { refreshTokens } from '@/auth';
import { mapGetters } from 'vuex';
import { resetExpInSec } from '@/service/token-info-service';
import desktopNotificationService from '@/service/desktop-notification-service';

// components
import BBasicDialog from '@/components/global_components/dialogs/BBasicDialog';
import BHint from '@/components/base_components/BHint';

export default {
  name: 'BeforeLogoutDialog',
  components: { BBasicDialog, BHint },
  computed: {
    ...mapGetters('tokenCounter', ['getExpInSecCounter']),
    statusNotifications() {
      return desktopNotificationService.checkDesktopNotificationStatus();
    },
  },
  methods: {
    open() {
      return this.$refs.basicDialog.open();
    },
    preventLogout() {
      resetExpInSec();
      refreshTokens();
      this.$refs.basicDialog.close();
    },
    notificationIfNotFocused() {
      if (!document.hasFocus()) {
        if (Notification.permission === 'granted') {
          desktopNotificationService.createNotification(
            'Ergebnismonitoring-Tool',
            {
              body:
                'Achtung! ' + this.getExpInSecCounter + ' Sekunden bis Logout!',
            }
          );
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.time {
  color: red;
  font-weight: 600;
}
</style>
